module.exports = __webpack_public_path__ + "img/slide6.0026d9ca.png";